import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
// import { RichEditorConfigContext } from "../contexts";
// import { GithubPicker } from "react-color";
// import {Picker} from "emoji-mart";
// import { motion, AnimatePresence } from "framer-motion";

import ToolbarButton from "./EditorToolbarButton";
// import { withTranslation } from "react-i18next";

// import uiStore from "../stores/uiStore";

import cx from "classnames";
import { t } from "i18next";
import s from "./toolbar.scss";

import {
  Icon,
  unorderedList,
  unlink,
  underline,
  textColor,
  strike,
  quoteFill,
  outdent,
  orderList,
  link,
  italic,
  indent,
  image,
  html,
  emoticon,
  clearFormatting,
  bold,
  bgColor,
  alignCenter,
  alignLeft,
  alignRight,
} from "Icons/index";

//import SVGInline from "react-svg-inline";
// import alignCenterFill from "../icons/alignCenter.svg";
// import alignLeftFill from "../icons/alignLeft.svg";
// import alignRightFill from "../icons/alignRight.svg";
// import orderListFill from "../icons/orderList.svg";
// import unorderListFill from "../icons/unorderList.svg";

const createDOMPurify = require("dompurify");

const REGEXPS = {
  bold: new RegExp("(\\W|^)B(\\W|$)"),
  italic: new RegExp("(\\W|^)I(\\W|$)"),
  underline: new RegExp("(\\W|^)U(\\W|$)"),
  strike: new RegExp("(\\W|^)DEL(\\W|$)"),
  quote: new RegExp("(\\W|^)BLOCKQUOTE(\\W|$)"),
};

const TAGS = {
  bold: "B",
  italic: "I",
  underline: "U",
  strike: "DEL",
};

const DEFAULT_FONT_SIZE = "14px";
const DEFAULT_FONT_FAMILY = "sans-serif";

/* DOM helpers functions */
const sumPixels = (a, b) => `${parseInt(a, 10) + parseInt(b, 10)}px`;
const diffPixels = (a, b) => {
  let diff = parseInt(a, 10) - parseInt(b, 10);
  if (diff < 0) diff = 0;
  return `${diff}px`;
};

const ContextTypes = {
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class Toolbar extends React.Component {
  state = {
    status: {
      textColor: "#000000",
      bgColor: "#ffffff",
      plainTextMode: false,
    },
    showAdvancedToolbar: false,
    isSelectingBgColor: false,
    showColorPicker: false,
    EDITOR_BODY_SELECTOR: `#editor${this.props.id} #editor-body`,
  };

  componentDidMount() {
    const { editor } = this.props;
    // configure event handling
    editor.addEventListener("pathChange", this.checkFormatting);

    window.DOMPurify = createDOMPurify();
  }

  componentWillUnmount() {
    // clean up the mess
    this.props.editor.removeEventListener("pathChange", this.checkFormatting);
  }

  checkFormatting = () => {
    let status = {};
    const { editor } = this.props;

    const path = editor.getPath();

    // handle inline tags
    if (path === "(selection)") {
      for (let t in TAGS) {
        if (editor.hasFormat(TAGS[t])) status[t] = true;
      }
    } else {
      if (path.match(REGEXPS.bold)) status.bold = true;
      if (path.match(REGEXPS.italic)) status.italic = true;
      if (path.match(REGEXPS.underline)) status.underline = true;
      if (path.match(REGEXPS.strike)) status.strike = true;
      if (path.match(REGEXPS.bold)) status.bold = true;
      if (path.match(REGEXPS.bold)) status.bold = true;
      if (path.match(REGEXPS.quote)) status.quoted = true;

      // handle indentetion
      if (path.match(new RegExp("..qb_indented"))) {
        status.indented = true;
      } else {
        status.indented = false;
      }

      // handle text color
      if (path.match(new RegExp("SPAN.colour"))) {
        const re = /SPAN\.colour\[color=(.*?)\]/;
        const c = path.match(re)[1];
        status.textColor = c;

        const drop = document.getElementById("color-drop");
        if (drop) drop.style.fill = c;
      } else {
        const drop = document.getElementById("color-drop");
        if (drop) drop.style.fill = "white";
      }

      // handle text bg color
      if (path.match(new RegExp("SPAN.highlight"))) {
        const re = /SPAN\.highlight\[backgroundColor=(.*?)\]/;
        const c = path.match(re)[1];
        status.bgColor = c;
        const bg = document.getElementById("color-point");
        if (bg) bg.style.fill = c;
      } else {
        const bg = document.getElementById("color-point");
        if (bg) bg.style.fill = "white";
      }

      // enable remove link when selected text is a link
      if (path.match(/\W*A(\W|$)/)) {
        status.onLink = true;
      }

      // enable remove list when selected text or cursor is on a list
      if (path.match(new RegExp("UL>"))) {
        status.unorderedList = true;
      }

      if (path.match(new RegExp("OL>"))) {
        status.orderedList = true;
      }

      let capture = path.match(new RegExp(/font\[fontFamily=(.*?),/));
      if (capture && capture[1]) {
        status.fontFamily = capture[1];
      } else {
        // set default value
        status.fontFamily = DEFAULT_FONT_FAMILY;
      }

      capture = path.match(new RegExp(/size\[fontSize=(\d*)/));
      if (capture && capture[1]) {
        let size = capture[1];
        status.fontSize = `${size}px`;
      } else {
        // set default value
        status.fontSize = DEFAULT_FONT_SIZE;
      }
    }

    if (path.match(new RegExp(/\.align-left/))) {
      status.align = "left";
    } else if (path.match(new RegExp(/\.align-center/))) {
      status.align = "center";
    } else if (path.match(new RegExp(/\.align-right/))) {
      status.align = "right";
    }

    this.setState({ status: status });
  };

  setQuotesInlineStyles = () => {
    const editorBody = document.querySelector(this.state.EDITOR_BODY_SELECTOR);
    const quotes = editorBody.querySelectorAll("blockquote");

    quotes.forEach((q) => {
      q.style.borderLeft = "2px solid #a8a8a8";
      q.style.paddingLeft = "10px";
      q.style.marginTop = ".5rem";
      q.style.marginBlockStart = "0px";
      q.style.marginInlineStart = "0px";
    });
  };

  action = (e) => {
    const { editor } = this.props;
    const { status } = this.state;
    let action = e.currentTarget.dataset.action;

    switch (action) {
      case "bold":
        status.bold ? editor.removeBold() : editor.bold();
        break;
      case "italic":
        status.italic ? editor.removeItalic() : editor.italic();
        break;
      case "underline":
        status.underline ? editor.removeUnderline() : editor.underline();
        break;
      case "strike":
        status.strike ? editor.removeStrike() : editor.strike();
        break;
      case "image-inline":
        document.getElementById("imginlineupload").click();
        break;
      case "make-link":
        const selection = editor.getSelection();
        let mode, urlText;

        let aHref = "";
        let aElement;

        if (selection.endContainer.nodeName === "A") aElement = selection.endContainer;
        if (selection.endContainer.parentNode.closest("a")) {
          aElement = selection.endContainer.parentNode.closest("a");
        }

        if (aElement) {
          mode = "edit";
          urlText = aElement.innerText;
          aHref = aElement.href;
        } else if (selection.collapsed || !selection) {
          // if no selection
          mode = "create";
          urlText = "";
        } else {
          mode = "create-from-selection";
          urlText = editor.getSelectedText();
        }

        this.props.showUrlEditDialog(aHref, urlText, mode, aElement);

        break;
      case "remove-link":
        editor.removeLink();

        break;
      case "align-left":
        editor.setTextAlignment("left");
        break;
      case "align-center":
        editor.setTextAlignment("center");
        break;
      case "align-right":
        editor.setTextAlignment("right");
        break;
      case "align-justify":
        editor.setTextAlignment("justify");
        break;
      case "font-size":
        this.setState({ status: { ...status, fontSize: e.currentTarget.value } });
        editor.setFontSize(e.currentTarget.value);
        break;
      case "font-family":
        this.setState({ status: { ...status, fontFamily: e.currentTarget.value } });
        editor.setFontFace(e.currentTarget.value);
        break;
      case "quote":
        if (status.quoted) {
          editor.decreaseQuoteLevel();
        } else {
          editor.increaseQuoteLevel();
          this.setQuotesInlineStyles();
        }

        break;

      case "decrease-indent":
      case "increase-indent":
        editor.modifyBlocks(function (frag) {
          let edited = new DocumentFragment();
          Array.from(frag.children).forEach((node) => {
            const operation = action === "increase-indent" ? sumPixels : diffPixels;
            node.style.marginLeft = operation(node.style.marginLeft || 0, "20px");

            if (!node.style.marginLeft || node.style.marginLeft === "0px") {
              node.classList.remove("qb_indented");
            } else {
              node.classList.add("qb_indented");
            }

            edited.appendChild(node);
          });

          return edited;
        });
        editor.focus();
        break;

      case "remove-formatting":
        editor.removeAllFormatting();
        break;
      case "ordered-list":
        if (status.orderedList) {
          editor.removeList();
        } else {
          editor.makeOrderedList();
        }

        break;
      case "unordered-list":
        if (status.unorderedList) {
          editor.removeList();
        } else {
          editor.makeUnorderedList();
        }

        break;
      case "remove-list":
        editor.removeList();
        break;
      case "toggle-mode":
        if (status.plainTextMode) {
          this.setState({
            status: {
              ...status,
              plainTextMode: true,
            },
          });
        } else {
          this.setState({
            status: {
              ...status,
              plainTextMode: true,
            },
          });

          this.setState({
            status: {
              ...status,
              plainTextMode: false,
            },
          });
        }

        editor.removeList();
        break;
      default:
      // code
    }
    this.checkFormatting();
  };

  actionColor = (color, type) => {
    const { editor } = this.props;
    const { status } = this.state;

    if (type === "bgColor") {
      editor.setHighlightColour(color);
      this.setState({
        status: { ...status, bgColor: color },
      });
      document.getElementById("color-point").style.fill = color;
    }

    if (type === "textColor") {
      editor.setTextColour(color);
      this.setState({
        status: { ...status, textColor: color },
      });

      const drop = document.getElementById("color-drop");
      if (drop) drop.style.fill = color;
    }
  };

  // toggleEmojiPicker = () => {
  //   const next = !this.state.showEmojiPicker;
  //   const editorBody = document.querySelector(this.state.EDITOR_BODY_SELECTOR);

  //   if (next) {
  //     editorBody.addEventListener("click", this.toggleEmojiPicker);
  //   } else {
  //     editorBody.removeEventListener("click", this.toggleEmojiPicker);
  //   }

  //   this.setState({showEmojiPicker: next});
  // };

  insertEmoji = (em) => this.props.editor.insertHTML(em.native);

  closeColorPicker = (e) => {
    const { EDITOR_BODY_SELECTOR } = this.state;
    if (e.type === "keydown") {
      if (e.key === "Escape") this.setState({ showColorPicker: false });
    } else if (e.type === "click") {
      this.setState({ showColorPicker: false, isSelectingBgColor: false });
    }

    if (document.querySelector(EDITOR_BODY_SELECTOR)) {
      document.querySelector(EDITOR_BODY_SELECTOR).removeEventListener("click", this.closeColorPicker);
    }

    document.removeEventListener("keydown", this.closeColorPicker);
  };

  toggleColorPicker = (isBg) => {
    const { EDITOR_BODY_SELECTOR } = this.state;
    let nextState = !this.state.showColorPicker;

    let nextBgState = isBg ? !this.state.isSelectingBgColor : false;

    this.setState({
      showColorPicker: nextState,
      isSelectingBgColor: nextState ? nextBgState : false,
      // showEmojiPicker: false,
    });

    if (nextState) {
      document.querySelector(EDITOR_BODY_SELECTOR).addEventListener("click", this.closeColorPicker);
      document.addEventListener("keydown", this.closeColorPicker);
    } else {
      document.querySelector(EDITOR_BODY_SELECTOR).removeEventListener("click", this.closeColorPicker);
      document.removeEventListener("keydown", this.closeColorPicker);
    }
  };

  showInsertRawHTML = () => {
    this.props.showRawHTMLDialog();
  };

  render() {
    const { className, onAddImage } = this.props;

    const {
      status,
      // showEmojiPicker,
      showAdvancedToolbar,
      showColorPicker,
      isSelectingBgColor,
    } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    // simple bar version, used in signature editor for example
    return (
      <div className={cx(s.toolbar, className)} id={"toolbarSimple"}>
        <ToolbarButton
          title={t("buttonIcons.bold")}
          icon={bold}
          data={{ "data-action": "bold" }}
          onClick={this.action}
          active={status.bold}
        />

        <ToolbarButton
          title={t("buttonIcons.italic")}
          icon={italic}
          onClick={this.action}
          data={{ "data-action": "italic" }}
          active={status.italic}
        />

        <ToolbarButton
          title={t("buttonIcons.underline")}
          icon={underline}
          onClick={this.action}
          data={{ "data-action": "underline" }}
          active={status.underline}
        />

        <ToolbarButton
          title={t("buttonIcons.strike")}
          icon={strike}
          onClick={this.action}
          data={{ "data-action": "strike" }}
          active={status.strike}
        />

        <div className={s.iconsDivider} />

        <ToolbarButton
          title={status.onLink ? t("buttonIcons.remove.link") : t("buttonIcons.insert.link")}
          icon={status.onLink ? unlink : link}
          data={{ "data-action": "make-link" }}
          onClick={this.action}
        />

        <ToolbarButton title={t("buttonIcons.add.image")} icon={image} className={s.tbButton} onClick={onAddImage} />

        {!isMobileDevice() && (
          <ToolbarButton
            title={t("buttonIcons.insert.HTML")}
            icon={html}
            className={s.tbButton}
            onClick={this.showInsertRawHTML}
          />
        )}

        <div className={s.iconsDivider} />

        <ToolbarButton
          title={t("buttonIcons.remove.formatting")}
          icon={clearFormatting}
          className={s.tbButton}
          onClick={this.action}
          data={{ "data-action": "remove-formatting" }}
        />
      </div>
    );
  }
}

Toolbar.contextTypes = ContextTypes;
export default Toolbar;
